
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var LogoStarsBlack = function (_React$PureComponent) {
  _inherits(LogoStarsBlack, _React$PureComponent);

  function LogoStarsBlack() {
    _classCallCheck(this, LogoStarsBlack);

    return _possibleConstructorReturn(this, (LogoStarsBlack.__proto__ || Object.getPrototypeOf(LogoStarsBlack)).apply(this, arguments));
  }

  _createClass(LogoStarsBlack, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var containerStyle = {};
      Object.keys(this.props.containerStyle).forEach(function (key) {
        containerStyle[key] = _this2.props.containerStyle[key];
      });
      if (!containerStyle.position || containerStyle.position === 'static') {
        containerStyle.position = 'relative';
      }
      containerStyle.paddingBottom = '100%';

      var svgStyle = {};
      Object.keys(this.props.svgStyle).forEach(function (key) {
        svgStyle[key] = _this2.props.svgStyle[key];
      });
      svgStyle.position = 'absolute';
      svgStyle.overflow = 'hidden';
      svgStyle.top = 0;
      svgStyle.left = 0;
      svgStyle.width = '100%';

      var text = !this.props.alt ? null : React.createElement(
        'div',
        { style: { position: 'absolute', left: -9999 } },
        this.props.alt
      );

      return React.createElement(
        'div',
        {
          style: containerStyle,
          className: this.props.containerClassName
        },
        React.createElement(
          'svg',
          { 'aria-hidden': true,
            focusable: 'false',
            style: svgStyle,
            className: this.props.svgClassName, 'data-name': 'Layer 1', viewBox: '0 0 216 216' },
          React.createElement('path', { fill: '#1f3349', d: 'M131.858 97.319l7.621-15.67 15.67-7.623-15.67-7.621-7.621-15.67-7.622 15.67-15.67 7.621 15.67 7.623 7.622 15.67zM58.446 91.093l5.586-11.481 11.481-5.586-11.481-5.584-5.586-11.483-5.584 11.483-11.483 5.584 11.483 5.586 5.584 11.481zM132.618 131.131l-5.585 11.483-11.482 5.584 11.482 5.584 5.585 11.483 5.584-11.483 11.483-5.584-11.483-5.584-5.584-11.483z' })
        ),
        text
      );
    }
  }]);

  return LogoStarsBlack;
}(React.PureComponent);

LogoStarsBlack.defaultProps = {
  containerStyle: {},
  svgStyle: {}
};
module.exports = LogoStarsBlack;